import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/toaster";
import Layout from "@/components/Layout";
import Discover from "@/pages/Discover";
import Explore from "@/pages/Explore";
import MapPage from "@/pages/MapPage";
import Favorites from "@/pages/Favorites";
import Profile from "@/pages/Profile";
import PlaceDetail from "@/pages/PlaceDetail";
import CollectionDetail from "@/pages/CollectionDetail";
import Admin from "@/pages/admin/Admin";
import AuthCallback from "@/pages/AuthCallback";
import SharedList from "@/pages/SharedList";
import Community from "@/pages/Community";
import Assistant from "@/pages/Assistant";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Discover />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/place/:id" element={<PlaceDetail />} />
        <Route path="/collection/:slug" element={<CollectionDetail />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/s/:shareId" element={<SharedList />} />
        <Route path="/community" element={<Community />} />
        <Route path="/assistant" element={<Assistant />} />
        <Route path="*" element={<Discover />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
